<template>
  <div class="counters-setup">
    <div class="d-flex align-center">
      <h1 class="mr-4">Configuration des compteurs</h1>
      <v-btn
        icon
        small
        color="error"
        @click="resetForm"
        title="Réinitialiser le formulaire">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <div class="setup-container">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <counters-selector-autocomplete v-model="selectedCounters" />
            <p
              v-if="selectedCounters.length"
              class="caption">
              Nombre de compteurs sélectionnés : {{ selectedCounters.length }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="6">
            <v-text-field
              v-model.number="numberOfLabels"
              label="Nombre de labels à imprimer"
              type="number"
              min="0"
              max="2"
              :rules="[(v) => (v >= 0 && v <= 2) || 'Le nombre doit être entre 0 et 2']"
              dense></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-for="option in tagOptions"
              :key="option.value"
              v-model="selectedTags"
              :label="option.label"
              :value="option.value"
              hide-details
              dense></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="enableFirmwareSelection"
              label="Mettre à jour le firmware"
              hide-details
              dense></v-checkbox>
            <v-select
              v-model="selectedFirmware"
              :items="firmwareList"
              label="Version du firmware"
              item-text="id"
              item-value="id"
              :disabled="!enableFirmwareSelection"
              dense></v-select>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          color="success"
          :disabled="!isFormValid"
          :loading="loading"
          @click="submitForm">
          Envoyer
        </v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import countersSelectorAutocomplete from '../components/selectors/countersSelectorAutocomplete.vue'
import setupCounterService from '../services/setupCounter.services'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CountersSetup',
  components: {
    countersSelectorAutocomplete,
  },
  data() {
    return {
      scan: '',
      selectedCounters: [],
      device: new Map(),
      numberOfLabels: 2,
      selectedTags: ['No_Self_GPS', 'Metal'],
      selectedFirmware: null,
      enableFirmwareSelection: false,
      loading: false,
      tagOptions: [
        {
          label: 'Self GPS retirée',
          value: 'No_Self_GPS',
        },
        {
          label: 'Détecteur de Métal',
          value: 'Metal',
        },
        {
          label: 'RTK',
          value: 'RTK',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['firmwareList']),
    isFormValid() {
      return this.selectedCounters.length > 0
    },
  },
  async mounted() {
    this.getFirmwareLists()
  },
  methods: {
    ...mapActions(['getFirmwareLists']),
    resetForm() {
      this.selectedCounters = []
      this.numberOfLabels = 2
      this.selectedTags = ['No_Self_GPS', 'Metal']
      this.selectedFirmware = null
      this.enableFirmwareSelection = false
    },
    async submitForm() {
      this.loading = true
      try {
        const payload = {
          counterIds: this.selectedCounters,
          printLabel: this.numberOfLabels,
          tags: this.selectedTags,
          ...(this.enableFirmwareSelection && { firmware: this.selectedFirmware }),
        }
        await setupCounterService.setupCounter(payload)

        this.resetForm()
      } catch (error) {
        console.error('Error submitting form:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.counters-setup {
  padding: 20px;
}

.setup-container {
  margin-top: 20px;
}
</style>
